"use client"

import { useState, useEffect, useCallback } from "react"
import { useAuth0 } from "@auth0/auth0-react"
import { getApiBaseUrl } from "../../config/apiBase"

export const useFetchCampaignsByProblem = (problemId) => {
  const [campaigns, setCampaigns] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { getAccessTokenSilently } = useAuth0()
  const apiUrl = getApiBaseUrl()

  const fetchCampaigns = useCallback(async () => {
    if (!problemId) {
      setLoading(false)
      setCampaigns([])
      return
    }

    try {
      setLoading(true)
      setError(null)
      
      const token = await getAccessTokenSilently({
        authorizationParams: {
          audience: process.env.REACT_APP_API_AUDIENCE,
        },
      })

      const response = await fetch(`${apiUrl}/api/Campaigns/problem/${problemId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.ok) {
        const data = await response.json()
        setCampaigns(data)
      } else {
        console.error("Failed to fetch campaigns:", response.statusText)
        setError("Failed to load ideas. Please try again later.")
      }
    } catch (error) {
      console.error("Error fetching campaigns:", error.message)
      setError("Failed to load ideas. Please try again later.")
    } finally {
      setLoading(false)
    }
  }, [problemId, getAccessTokenSilently, apiUrl])

  useEffect(() => {
    let isMounted = true

    const loadCampaigns = async () => {
      if (isMounted) {
        await fetchCampaigns()
      }
    }

    loadCampaigns()

    return () => {
      isMounted = false
    }
  }, [fetchCampaigns])

  return { campaigns, loading, error, refetch: fetchCampaigns }
}

export default useFetchCampaignsByProblem
